import React, { useState } from 'react';
import { message, Typography, Form, Icon, Input, Button } from 'antd';
import {flexCenter, minHeight, primaryTextColor} from './../theme';
import { login } from './../API';
import { useDispatch } from 'redux-react-hook';
import moment from 'moment';
const { Title } = Typography;

function NormalLoginForm({form}) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    setLoading(true);
    e.preventDefault();

    try {
      const formResult = await form.validateFields();
      const loginResult = await login(formResult);
      setLoading(false);
      if (loginResult.data.responseCode !== 0) {
        message.error(loginResult.data.message)
      }
      else {
        dispatch({type: "INIT_SESSION", payload: loginResult.data.data});
        message.success(loginResult.data.message);
      }
    }
    catch {
      setLoading(false);
    }
  };

  const { getFieldDecorator } = form;

  return (
    <div style={{...flexCenter, ...minHeight}}>
      <Form onSubmit={handleSubmit}>
        <Title style={{...primaryTextColor, ...{textAlign: 'center'}}} level={3}>
          Link Global Recruitment
        </Title>
        <br/>
        <br/>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [{ required: true, message: 'Please input your email!' }],
          })(
            <Input autoComplete="off" size="large"
              prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="email"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input autoComplete="off" size="large"
              prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="password"
              placeholder="Password"
            />,
          )}
        </Form.Item>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" style={{width: '100%'}}>
            {loading ? <Icon type="loading" /> : <Icon type="login" />}
            Log in
          </Button>
        </Form.Item>
      </Form>

      <div style={{
        position: "absolute",
        left: 0,
        bottom: 0,
        height: "40px",
        width: "100%",
      }}>
        <center>
          {`© 2020 - ${moment().format('YYYY')} Copyright Link Global. All Rights Reserved. v${process.env.REACT_APP_VERSION}`}
        </center>
      </div>
    </div>
  );
}

const WrappedNormalLoginForm = Form.create({ name: 'login' })(NormalLoginForm);

export default WrappedNormalLoginForm
